import { Injectable } from '@angular/core';
import { Subject, interval, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InternetConnectivityService {
  private isOnline: boolean = navigator.onLine;
  private internetStatusChanged: Subject<boolean> = new Subject<boolean>();

  constructor(private http: HttpClient) {
    window.addEventListener('online', () => {
      this.handleInternetStatusChange();
    });

    window.addEventListener('offline', () => {
      this.handleInternetStatusChange();
    });

    // Check internet connectivity periodically
   /*  interval(2000).subscribe(() => {
      this.checkInternetConnectivity().subscribe(isConnected => {
        if (this.isOnline !== isConnected) {
          this.handleInternetStatusChange();
        }
      });
    }); */
  }

  private handleInternetStatusChange(): void {
    const isCurrentlyOnline = this.isOnline;
    this.isOnline = navigator.onLine;

    if (isCurrentlyOnline !== this.isOnline) {
      this.internetStatusChanged.next(this.isOnline);
    }
  }

  private checkInternetConnectivity(): Observable<boolean> {
    return this.http.get('https://mycrm.apollocare.in/assets/images/logo-quad-one.png').pipe(
      map(() => true),
      catchError(() => of(false))
    ) as Observable<boolean>;
  }

  public isInternetConnected(): boolean {
    return this.isOnline;
  }

  public getInternetStatusChanged(): Observable<boolean> {
    return this.internetStatusChanged.asObservable();
  }
}
